export default __webpack_public_path__ + "static/media/d16948c99e21735a3118fa494a13aa09.637a9e15.png";